export default __webpack_public_path__ + "static/media/icon-inpatient.e991f0f5.svg";